import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

interface StyleProps {
  width?: string | number;
  light?: boolean;
}

export const useStyles = ({ width, light }: StyleProps) =>
  ({
    filterSeparator: {
      alignSelf: "stretch",
      flexShrink: "0",
      width: width,
      background: light ? colors.gray200 : colors.gray300,
      margin: "0 16px"
    }
  }) as CSSObject;
